import { Manager, ManagerPaycloud } from "../types";
import BaseService from "./base-service";
import { GetAllManagersParams } from "./dto/request/manager-request-dto";
import { RequestDto } from "./dto/request/request-dto";
import { GetManagersResponse, DeleteManagerResponse } from "./dto/response/manager-response-dto";

export class ManagerService extends BaseService {
  private resource = "/api/managers";

  async getAllManagers(
    params: GetAllManagersParams | undefined,
    onSuccess: (data: ManagerPaycloud[]) => void,
    onError: (errorMessage: string) => void
  ) {
    const reqParams = new RequestDto(this.resource, params);
    await this.doGet<ManagerPaycloud[]>(reqParams, onSuccess, onError);
  }

  async createManager(
    params: {
      FirstName: string;
      LastName: string;
      Email: string;
      IdentityType: string;
      IdentityNumber: string;
      Address: string;
      Phone: string;
      DepartmentId: string;
      CityId: string;
      BranchesIds: number[];
      CountryCode: string;
    },
    onSuccess: (data: GetManagersResponse) => void,
    onError: (errorMessage: string) => void
  ) {
    const reqParams = new RequestDto(`${this.resource}`, params);
    await this.doPost<GetManagersResponse>(reqParams, onSuccess, onError);
  }

  async updateManager(
    managerId: number,
    params: {
      FirstName: string;
      LastName: string;
      Email: string;
      IdentityType: string;
      IdentityNumber: string;
      Address: string;
      Phone: string;
      DepartmentId: string;
      CityId: string;
      BranchesIds: number[];
      CountryCode: string;
    },
    onSuccess: (data: Manager) => void,
    onError: (errorMessage: string) => void
  ) {
    const reqParams = new RequestDto(`${this.resource}/${managerId}`, params);
    await this.doPatch<Manager>(reqParams, onSuccess, onError);
  }

  async deleteManager(
    managerId: number,
    onSuccess: (data: DeleteManagerResponse ) => void,
    onError: (errorMessage: string) => void
  ) {
    const reqParams = new RequestDto(`${this.resource}/${managerId}`, {});
    await this.doDelete<DeleteManagerResponse>(reqParams, onSuccess, onError);

  }
  
}

